import { AiIcon, FormLabel, Stack, Tag } from '@all-manager/design-system-v2';
import type { ReactNode } from 'react';
import Editor from "../../Editor";

type DescriptionFieldProps = {
  value: string | undefined | null;
  onChange: (newValue: string) => void;
  label?: string;
  isAiGenerated?: boolean;
  action?: ReactNode;
  readOnly?: boolean;
};

export default function DescriptionField(props: DescriptionFieldProps) {
  return (
    <Stack spacing={0.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} wrap="wrap">
        <FormLabel>{props.label ?? 'Description'}</FormLabel>
        <Stack direction="row" alignItems="center" spacing={1}>
          {props.action}
          {props.isAiGenerated ? (
            <Tag color="ai" icon={<AiIcon fontSize="small" />} label="Description générée" />
          ) : null}
        </Stack>
      </Stack>
      <Editor
        value={props.value ?? ''}
        onChange={props.onChange}
        readOnly={props.readOnly}
      />
    </Stack>
  );
}
